module.exports = __webpack_public_path__ + "img/page26.aec053c0.gif";